import { render, staticRenderFns } from "./ServidorMenu.vue?vue&type=template&id=97e93e3c&scoped=true&"
import script from "./ServidorMenu.vue?vue&type=script&lang=js&"
export * from "./ServidorMenu.vue?vue&type=script&lang=js&"
import style0 from "./ServidorMenu.vue?vue&type=style&index=0&id=97e93e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e93e3c",
  null
  
)

export default component.exports